<template>
  <div class="GroupChatroom">
    <van-nav-bar
      :title="title"
      fixed
      border
      class="van-nav"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
      <template #right>
        <img class="more" src="../../assets/img/icon/more.png" alt />
      </template>
    </van-nav-bar>
    <div :class="showmsg==false?'van-collapse':'collapse1'" v-show="shownotice && groupNotice">
      <p class="notice" v-html="groupNotice"></p>
      <div @click="noticeshow">
        <img src="../../assets/img/icon/down-arrow.png" alt />
      </div>
    </div>
    <van-pull-refresh v-model="isloading" @refresh="reloadMoreMsg">
      <div id="content" ref="ref_content" :style="{height: scrollerHeight}">
        <audio :src="musicUrl" ref="msgaudio"></audio>
        <div :style="{'display':videoshow==true?'block':'none'}">
          <video :src="videoUrl" ref="msgvideo" style="width:200px;height:160px;" preload="auto"></video>
        </div>
        <!-- <van-loading v-if="videoFlag==true" type="spinner" color="#1989fa" /> -->
        <template v-for="(item,index) in chatMessage">
          <div :ref="'ref_msg_1'+item.gm_id">
            <div v-if="item.ug_type=='notice'" class="notice-content">{{item.gm_content}}</div>
            <!-- 右对齐 -->
            <van-row
              type="flex"
              justify="end"
              v-if="item.gm_from_id == u_id && item.ug_type!='notice'"
              :key="index+'a'"
              @click.stop="selectOption(item.gm_id,item.gm_from_id,item.ug_admin_id,item.create_time,item.ug_type,item.gm_content,item.duration)"
            >
              <div class="msg-box" :ref="'ref_msg_'+item.gm_id">
                <van-image
                  class="err-image-header"
                  round
                  width="45px"
                  height="45px"
                  :src="attach_url+item.u_headportrait"
                  @click="headPortrait(item.u_id)"
                />
                <van-col>
                  <div class="van-div-right">
                    <span class="time">{{item.create_time*1000|moment_format('M-D HH:mm')}}</span>
                  </div>
                  <div
                    :class="item.ug_type=='video' || item.ug_type == 'image' ?'entryimg2':'entry2'"
                  >
                    <div class="entry-trangle-right">
                      <!--本Div只来实现三角形，无其他作用-->
                    </div>
                    <span
                      v-if="item.ug_type =='text'"
                      :class="[isUrl(item.gm_content) == true? 'span-url span-content':'span-content']"
                      :style="{'font-size':(WindValue+'px'),'line-height':(WindValue+6+'px')}"
                      @click="CheckUrl(item.gm_content)"
                      v-html="analyzeEmoji(item.gm_content)"
                    >{{item.gm_content}}</span>
                    <span
                      v-if="item.ug_type=='audio'"
                      class="span-content"
                      :style="{width:parseInt(item.duration/1000)*2+50+'px'}"
                      @click.stop="playaudio(attach_url+item.gm_content,item.gm_id)"
                    >
                      <div class="audio" style="text-align:right;">
                        <span>{{parseInt(item.duration/1000)}}"</span>
                        <img
                          style="transform: rotate(180deg);"
                          :id="item.gm_id"
                          src="../../assets/img/center/pause.png"
                          alt
                        />
                      </div>
                    </span>
                    <span
                      v-if="item.ug_type == 'video'"
                      @click.stop="playVideo(attach_url+item.gm_content,item.gm_id)"
                      class="span1-content"
                    >
                      <div class="video-box">
                        <img
                          class="videocover"
                          :src="attach_url+item.gm_content.replace('mp4', 'jpg')"
                          style="height:140px;width:90px;"
                          alt
                        />
                        <div class="video-img"></div>
                        <span class="duration">{{parseInt(item.duration)}}"</span>
                      </div>
                    </span>
                    <van-image
                      v-if="item.ug_type == 'image'"
                      width="100"
                      class="err-image-img"
                      :src="attach_url+item.gm_content"
                      @click.stop="showImage(attach_url+item.gm_content)"
                    />
                  </div>
                </van-col>
              </div>
              <input
                type="checkbox"
                v-show="select"
                :value="index"
                id="myCheck"
                v-model="selectArr"
                :checked="checked==item.m_id"
                @click.stop
              />
            </van-row>
            <!-- 左对齐 -->
            <van-row
              :class="select==true?'selectmore1':''"
              type="flex"
              v-else-if="item.ug_type!='notice'"
              :key="index+'b'"
              @click.stop="selectOption(item.gm_id,item.gm_from_id,item.ug_admin_id,item.create_time,item.ug_type,item.gm_content,item.duration)"
            >
              <div class="msg-box" ref="'ref_msg_'+item.gm_id">
                <van-image
                  round
                  width="45px"
                  height="45px"
                  style="float:left"
                  class="err-image-header"
                  :src="attach_url+item.u_headportrait"
                  @click="headPortrait(item.u_id)"
                />
                <van-col>
                  <div class="van-div-left">
                    <span>{{item.ug_group_nick?item.ug_group_nick:item.u_nickname?item.u_nickname:item.u_login_id}}</span>
                    <span class="time">{{item.create_time*1000|moment_format('M-D HH:mm')}}</span>
                  </div>

                  <div
                    :class="item.ug_type=='video' || item.ug_type == 'image' ?'entryimg2':'entry1'"
                    :ref="'ref_msg_'+item.gm_id"
                  >
                    <div class="entry-trangle-left">
                      <!--本Div只来实现三角形，无其他作用-->
                    </div>
                    <span
                      v-if="item.ug_type == 'text'"
                      @click="CheckUrl(item.gm_content)"
                      :class="[isUrl(item.gm_content) == true? 'span-url span-content':'span-content']"
                      :style="{'font-size':(WindValue+'px'),'line-height':(WindValue+6+'px')}"
                      v-html="analyzeEmoji(item.gm_content)"
                    >{{item.gm_content}}</span>
                    <span
                      v-if="item.ug_type=='audio'"
                      class="span-content"
                      :style="{width:parseInt(item.duration/1000)*2+50+'px'}"
                      @click.stop="playaudio(attach_url+item.gm_content,item.gm_id)"
                    >
                      <img :id="item.gm_id" src="../../assets/img/center/pause.png" alt />
                      <span>{{parseInt(item.duration/1000)}}"</span>
                    </span>
                    <!-- <span v-if="item.ug_type == 'video'" class="span1-content">
                      <div style="height:140px;width:200px;">
                        <video
                          id="video1"
                          style="height:140px;width:200px;object-fit:fill"
                          controls
                          preload="auto"
                          :src="attach_url+item.gm_content"
                          poster="attach_url+videoImg"
                        ></video>
                      </div>
                    </span>-->
                    <span
                      v-if="item.ug_type == 'video'"
                      class="span1-content"
                      @click.stop="playVideo(attach_url+item.gm_content,item.gm_id)"
                    >
                      <div class="video-box">
                        <!-- <video
                          :id="item.gm_id"
                          style="height:140px;width:90px;object-fit:fill;"
                          controls="controls"
                          preload="auto"
                          :src="attach_url+item.gm_content"
                        ></video>-->
                        <img
                          class="videocover1"
                          :src="attach_url+item.gm_content.replace('mp4', 'jpg')"
                          style="height:140px;width:90px;"
                          alt
                        />
                        <div class="video-img"></div>
                        <span class="duration">{{parseInt(item.duration)}}"</span>
                      </div>
                    </span>
                    <van-image
                      v-if="item.ug_type == 'image'"
                      width="100"
                      class="err-image-img"
                      :src="attach_url+item.gm_content"
                      @click.stop="showImage(attach_url+item.gm_content)"
                    />
                  </div>
                </van-col>
              </div>
              <input
                type="checkbox"
                v-show="select"
                :value="index"
                id="myCheck"
                v-model="selectArr"
                :checked="checked==item.m_id"
                @click.stop
              />
            </van-row>
          </div>
        </template>
        <van-popup
          v-model="show1"
          class="overly"
          :overlay-style="{backgroundColor:'transparent' }"
          :style="{width:'120px'}"
        >
          <div @click="delmsg(gm_id, create_time, ug_admin_id, gm_from_id)">
            <p v-if="new Date().getTime() - create_time * 1000 < 120000 && gm_from_id == u_id">撤回</p>
            <p v-else>删除</p>
          </div>
          <div @click="Copy(gm_id,gm_from_id,create_time,ug_type,gm_content)">
            <p v-if="ug_type=='text'">复制</p>
            <p
              v-else-if="(ug_type=='image') && platforms=='app'"
              @click.stop="downImg(attach_url+gm_content)"
            >保存到相册</p>
          </div>
          <p @click="transMsg(gm_id,gm_from_id,create_time,ug_type,gm_content.duration)">转发</p>
          <p @click.stop="choose(gm_id)">多选</p>
          <p @click.stop="delAll">清空记录</p>
        </van-popup>
      </div>
    </van-pull-refresh>
    <!-- 底部导航栏 -->
    <div
      class="bottom-bar"
      v-if="select"
      style="background-color:#fff;display:flex;justify-content:space-around;"
    >
      <div class="v1tabbar" style="background-color:#fff;" @click="transmit()">
        <img
          :disabled="isDisable"
          style="'width:18px;height:18px;vertical-align: middle;"
          class="face"
          src="../../assets/img/center/transpond.png"
          alt
        />
        <span style="font-size:16px;">转发</span>
      </div>
      <div @click="delmore(gm_id,gm_from_id,create_time,ug_type,gm_content)">
        <img
          :disabled="isDisable"
          style="'width:18px;height:18px;vertical-align: middle;"
          class="face"
          src="../../assets/img/center/delete.png"
        />
        <span style="font-size:16px;">删除</span>
      </div>
    </div>
    <div class="bottom-bar" v-else-if="platforms=='app'">
      <div class="v-tabbar">
        <img
          :class="banned==0?'face':'face1'"
          src="../../assets/img/icon/voice.png"
          @click="clickVoice(1)"
          v-if="voice == 0"
        />
        <img class="face" src="../../assets/img/icon/keybd.png" @click="clickVoice(0)" v-else />
        <div v-if="voice==1" class="voice">
          <van-button class="sendc" @click="handleBtnClick" v-show="!recordimg">开始录音</van-button>
          <van-popup v-model="recordimg" class="recordimg" :overlay="false">
            <img src="../../assets/img/center/record.gif" alt />
            <van-count-down
              ref="voiceCountDown"
              millisecond
              :time="voiceLimit"
              :auto-start="false"
              :format="voiceLimit>=60000?'mm:ss:SSS':'ss:SSS'"
              @finish="send_voice"
            />
          </van-popup>
          <van-button class="sendc" @click="cancel_voice" v-show="recordimg">取消录音</van-button>
          <van-button class="sendc" @click="send_voice" v-show="recordimg">发送</van-button>
        </div>
        <van-field
          v-else
          type="textarea"
          v-model="content"
          :clearable="true"
          :autosize="true"
          border
          :class="banned==0?'sendc':'sendc1'"
          :placeholder="banned==0?definte:definte1"
          :disabled="banned==0?false:true"
          @click="showOf()"
          @focus="closeOther()"
          @click-input="keyboard()"
        />
        <img
          :class="banned==0?'face':'face1'"
          src="../../assets/img/icon/face.png"
          alt
          @click="showface()"
        />
        <van-button
          class="send"
          v-if="content!=''"
          :style="{ width: '20%'}"
          type="info"
          @click="sendmsg"
        >发送</van-button>
        <img
          :class="banned==0?'face':'face1'"
          v-else
          src="../../assets/img/icon/plus.png"
          @click="showFunction()"
        />
      </div>
      <div v-show="faceshow" class="faceshow">
        <van-icon
          size="8"
          v-for="item in OwOlist"
          :key="item+''"
          :name="getOwOlistUrl()+item.url"
          @click="selectOwO(item.title)"
        />
      </div>
      <div class="functionshow" v-show="functionshow">
        <button class="f-button">
          <van-icon size="35" name="photograph" @click="photo()" />
        </button>
        <van-uploader capture :after-read="onSend" :before-read="beforeRead" accept="image/*">
          <button class="f-button">
            <van-icon size="35" name="photo" @click="O()" />
          </button>
        </van-uploader>
        <button class="f1-button">
          <input
            ref="uploadVideo"
            type="file"
            @change="sendVideo"
            accept="video/*"
            id="fileUpload"
            capture="camcorder"
            style="opacity:0; width:35px;"
          />
        </button>
      </div>
    </div>
    <div class="bottom-bar" v-else>
      <div class="v-tabbar">
        <van-field
          :class="banned==0?'sendc':'sendc1'"
          type="textarea"
          :clearable="true"
          :autosize="true"
          v-model="content"
          border
          :placeholder="banned==0?definte:definte1"
          :disabled="banned==0?false:true"
          @click="showOf()"
          @focus="closeOther()"
          @keyup.ctrl.enter.native="onTextareaKeyDown()"
        />
        <img
          :class="banned==0?'face':'face1'"
          src="../../assets/img/icon/face.png"
          alt
          @click="showface()"
        />
        <van-button
          class="send"
          v-if="content!=''"
          :style="{ width: '20%'}"
          type="info"
          @click="sendmsg"
        >发送</van-button>
        <img
          :class="banned==0?'face':'face1'"
          v-else
          src="../../assets/img/icon/plus.png"
          @click="showFunction()"
        />
      </div>
      <div v-show="faceshow" class="faceshow">
        <van-icon
          size="8"
          v-for="item in OwOlist"
          :key="item+''"
          :name="getOwOlistUrl()+item.url"
          @click="selectOwO(item.title)"
        />
      </div>
      <div class="functionshow" v-show="functionshow">
        <button class="f-button">
          <van-icon size="35" name="photograph" @click="photo()" />
        </button>
        <van-uploader capture :after-read="onSend" :before-read="beforeRead" accept="image/*">
          <button class="f-button">
            <van-icon size="35" name="photo" @click="O()" />
          </button>
        </van-uploader>
        <button class="f1-button">
          <input
            ref="uploadVideo"
            type="file"
            @change="sendVideo"
            accept="video/*"
            id="fileUpload"
            capture="camcorder"
            style="opacity:0; width:35px;"
          />
        </button>
      </div>
    </div>
    <!-- 图片发送 -->
    <van-popup
      v-model="photoShow"
      closeable
      close-icon="close"
      position="bottom"
      :style="{ height: '45%' }"
    >
      <van-tabbar :fixed="false">
        <van-button type="primary" @click="filesSend">发送</van-button>
      </van-tabbar>
      <van-uploader
        v-model="fileList"
        :after-read="onRead"
        :before-read="beforeRead"
        accept="image/*"
        :style="{'margin-top': '15%'}"
        :max-count="1"
      />
    </van-popup>

    <!-- 声音提醒 -->
    <audio controls="controls" hidden src="./static/mp3/msg.wav" ref="altaudio"></audio>
    <van-dialog
      v-model="showImgDialog"
      :showConfirmButton="false"
      :closeOnClickOverlay="true"
      class="img_dialog"
      @click="showImgDialog=false"
    >
      <img :src="image_url" style="width:100%;" @click="showImgDialog=false" />
    </van-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { utf16toEntities, chkImgType, chkURL } from "@/utils/common.js";
import { OwOlistUrl,analyzeEmoji,emojiList,compUploadImg,} from "@/utils/chat.js";
import Recorderx, { ENCODE_TYPE } from "recorderx";
const rc = new Recorderx();
export default {
	name: "GroupChatroom",
	data() {
		return {
			  photoShow: false,
			  faceshow: false,
			  functionshow: false,
			  textshow: false,
			  footHeight: 60,
			  recordimg: false,
			  voice: 0,
			  active: 0,
			  title: "",
			  group_manage: localStorage.getItem("group_manage"),
			  u_id: localStorage.getItem("u_id"),
			  ug_id: "",
			  fileList: [], // 回显图片
			  imagePath: [], // 上传图片路径
			  data: [],
			  titleList: [{ name: "表情" }, { name: "多媒体" }],
			  chatMessage: [],
			  show: false,
			  content: "",
			  token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			  OwOlist: emojiList,
			  winH: null,
			  Socket: "",
			  lockReconnect: false, //是否真正建立连接
			  timeout: 20000, //20秒一次心跳
			  timeoutObj: null, //心跳心跳倒计时
			  serverTimeoutObj: null, //心跳倒计时
			  timeoutnum: null, //断开 重连倒计时
			  attach_url: this.Conf.serverPre,
			  voiceStartTime: null,
			  refresh_more_time: 0,
			  voiceLimit: 30000,
			  filesizelimit: 10485760,
			  showImgDialog: false,
			  image_url: "",
			  platforms: null,
			  path: {
				url: "",
			  },
			  minMsgId: 0,
			  maxMsgId: "",
			  isloading: false,
			  reloadMoreMsgFlag: false,
			  Loop: 0,
			  // longClick: 0,
			  videoFlag: false,
			  activeNames: ["1"],
			  groupNotice: "",
			  shownotice: true,
			  banned: 0,
			  definte: "请输入内容",
			  definte1: "此群已禁言，暂时无法聊天",
			  showmsg: false,
			  connecting: false,
			  ug_admin_id: "",
			  ug_group_nick: "",
			  userinfo: JSON.parse(localStorage.getItem("userInfo")),
			  longClick: 0,
			  timeOutEvent: 0,
			  WindValue: localStorage.getItem("fontsize") ? parseInt(localStorage.getItem("fontsize")) : 12,
			  rannumber: 1,
			  latestInterTmer: false,
			  show1: false,
			  gm_id: "",
			  gm_from_id: "",
			  create_time: "",
			  ug_type: "",
			  gm_content: "",
			  transtat: "",
			  playstate: true,
			  // duration1:JSON.parse(localStorage.getItem("duration1")),
			  checkValue: "",
			  select: false,
			  checked: 0,
			  selectArr: [],
			  checkId: [],
			  transfer: false,
			  subArr: [],
			  ug_type: "",
			  isDisable: false,
			  musicUrl: "",
			  videoUrl: "",
			  videoshow: false,
			  duration:"",
			  nextplay:"",
			   msgshowList:JSON.parse(localStorage.getItem("msgshowLists")),
			  chkWebsocketTimer:false,
			  videoLengthLimit:20,
			  videoSizeLimit:10 * 1024 * 1024
		};
	},
	// 在模板渲染成html前调用，即通常初始化某些属性值，然后再渲染成视图。
	created() {
		this.getStateConfigs();
		this.chatMessage = [];
		var params = this.$route.query;
		this.ug_id = params.ug_id;
		this.title = params.ug_name;
		this.transtat = params.transtat;
		this.path.url = params.url;
		this.platforms = this.Conf.platform;
		this.getNotice();
	   
		this.chkSocketState();
	   
		this.loadData();
		setTimeout(() => {
			this.shownotice = false;
		}, 10000);
	},
	mounted() {
		this.connecting = this.websocket.connected;
		// if (this.$refs.ref_content.scrollHeight > 0) {
		//   this.$nextTick(() => {
		//     this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
		//   });
		// }
		 setTimeout(()=>{
			this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
		  },500)
	},
	computed: {
		// 滚动区高度
		// (业务需求：手机屏幕高度减去头部标题和底部tabbar的高度，当然这2个高度也是可以动态获取的)
		scrollerHeight: function () {
			return window.innerHeight - 40 - this.footHeight + "px";
		},
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
				if (confs.duration) {
				  this.voiceLimit =
					parseInt(confs.duration.values) * 1000;
				}
				if (confs.fileSize) {
					this.filesizelimit = parseInt(
						confs.fileSize.values
					);
				}
				if (confs.videoLength){
					this.videoLengthLimit = parseInt(confs.videoLength.values);
				}
				if (confs.videoSize){
					this.videoSizeLimit = parseInt(confs.videoSize.values);
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		loadData(sts) {
			var params = {
				u_id: this.u_id,
				ug_id: this.ug_id,
				token: this.token,
				msg_id: sts==1?this.minMsgId:0,
				max_id: sts==2?this.maxMsgId:0
			};
			var url = this.Conf.serverUrl + "GroupChatroom/getGrouproomById";
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then((response) => {
				localStorage.setItem("group_manage", response.data.group_manage);
				this.banned = response.data.banned_state;
				this.ug_admin_id = response.data.ug_admin_id;
				this.ug_group_nick = response.data.ug_group_nick;
				if (response.data.code == 200) {
					if (response.data.mk == 1) {
						for (var i in response.data.result) {
							this.chatMessage.push(response.data.result[i]);
							this.maxMsgId = response.data.result[i].gm_id>this.maxMsgId?response.data.result[i].gm_id:this.maxMsgId;
						}
					} else {
						for (var i in response.data.result) {
							this.chatMessage.unshift(response.data.result[i]);
							if (i == 0 && !this.maxMsgId) {
								this.maxMsgId = response.data.result[i].gm_id;
							}
							this.minMsgId = response.data.result[i].gm_id<this.minMsgId?response.data.result[i].gm_id:this.minMsgId;
						}
					}
					// this.scrollToBottom();
					this.reloadMoreMsgFlag = false;
				}
			})
			.catch((error) => {});
		},
		chkSocketState() {
			if ( this.globalWs && this.globalWs.ws && this.globalWs.ws.readyState == 1 ) {
				// 监听消息回调
				this.globalWs.ws.onmessage = this.getMessage;
				this.connecting = true;
				if (this.latestInterTmer) {
					clearInterval(this.latestInterTmer);
				}
			}else{
				this.connecting = false
				this.loadLatestMsg();
			}
			this.chkWebsocketTimer && clearTimeout(this.chkWebsocketTimer)
			this.chkWebsocketTimer = setTimeout(() => {
				this.chkSocketState();
			}, 2000);
		},
		scrollToBottom() {
			// 滚动
			if (this.$refs.ref_content.scrollHeight > 0) {
				this.$nextTick(() => {
					this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
				});
			}
		},
		photo() {
			this.photoShow = true;
		},
		selectOption(gm_id,gm_from_id,ug_admin_id,create_time,ug_type,gm_content,duration){
			if (this.select) {
				this.select = false;
				return;
			}
			this.gm_id = gm_id;
			this.gm_from_id = gm_from_id;
			this.ug_admin_id = ug_admin_id;
			this.create_time = create_time;
			this.ug_type = ug_type;
			this.gm_content = gm_content;
			this.duration = duration;
			this.show1 = true;
		},
		//清空所有聊天记录
		delAll() {
			this.show1 = false;
			this.$dialog
			.confirm({
			  title: "清空记录",
			  message: "确认清空所有聊天记录吗？",
			})
			.then(() => {
				var params = {
					m_id: "group",
					ug_id: this.ug_id,
					type: 2,
					u_id: this.u_id,
					token: this.token,
					num: Math.random(),
				};
				var url = this.Conf.serverUrl + "Friends/delMsg";
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then((response) => {
					switch (response.data.code) {
						case 200:
							this.chatMessage = "";
							break;
						case 40001:
							this.$toast.fail("清空失败！");
							break;
					}
				})
				.catch((error) => {});
			})
			.catch(() => {});
		  return false;
		},
		//批量删除
		delmore() {
			var that = this;
			this.isDisable = true;
			setTimeout(() => {
				that.isDisable = false;
			}, 1000);
			var len = that.chatMessage.length;
			for (var i = 0; i < len; i++) {
				if (this.selectArr.indexOf(i) >= 0) {
					that.subArr.push(that.chatMessage[i]);
				}
			}
			if (that.subArr.length == 0) {
				this.$toast.fail("请选择要删除的数据");
			} else {
				this.$dialog
				.confirm({
					title: "删除消息",
					message: "确认删除该条消息吗？",
				})
				.then(() => {
					for (let c in that.subArr) {
						var params = {
							gm_id: that.subArr[c].gm_id,
							state: 2,
							u_id: this.u_id,
							token: this.token,
							num: Math.random(),
						};
						var url = this.Conf.serverUrl + "GroupChatroom/deleteOneMsg";
						this.$axios
						.post(url, this.$qs.stringify(params))
						.then((response) => {
							switch (response.data.code) {
								case 200:
									var data = {
										ug_id: this.ug_id,
										u_id: this.u_id,
										gm_id: that.subArr[c].gm_id,
										mk: 6,
										type: 2,
									};
									this.websocket.ws.send(JSON.stringify(data));
									//this.websocket.ws.onmessage = this.getMessage;
									break;
								case 40001:
									this.$toast.fail("删除失败！");
									break;
							}
						})
						.catch((error) => {});
					}
			  })
			  .catch(() => {});
			return false;
		  }
		},
		//单条删除
		delmsg(gm_id, create_time, ug_admin_id, gm_from_id) {
			if (!this.websocket.connected) {
				return this.$toast("连接马上建立，请稍候...！");
			}
			this.show1 = false;
			if (
				new Date().getTime() - create_time * 1000 < 120000 &&
				gm_from_id == this.u_id
			) {
				var that = this;
				this.$dialog
				.confirm({
					title: "撤回消息",
					message: "确定撤回该条消息吗？",
				})
				.then(() => {
					var params = {
						gm_id: gm_id,
						u_id: this.u_id,
						token: this.token,
						state: 1,
						num: Math.random(),
					};
					var url = this.Conf.serverUrl + "GroupChatroom/deleteOneMsg";
					this.$axios
					.post(url, this.$qs.stringify(params))
					.then((response) => {
						switch (response.data.code) {
							case 200:
								var data = {
									ug_id: this.ug_id,
									u_id: this.u_id,
									gm_id: gm_id,
									mk: 6,
									type: 1,
								};
								this.websocket.ws.send(JSON.stringify(data));
								break;
							case 40001:
								this.$toast.fail("撤回失败！");
								break;
						}
					})
					.catch((error) => {});
				})
				.catch(() => {});
				return false;
			} else if (ug_admin_id == this.u_id || this.group_manage == 1) {
				var that = this;
				this.$dialog
				.confirm({
					title: "删除消息",
					message: "确定删除该条消息吗？",
				})
				.then(() => {
					var params = {
						gm_id: gm_id,
						u_id: this.u_id,
						token: this.token,
						state: 2,
						num: Math.random(),
					};
					var url = this.Conf.serverUrl + "GroupChatroom/deleteOneMsg";
					this.$axios
					.post(url, this.$qs.stringify(params))
					.then((response) => {
						switch (response.data.code) {
							case 200:
								var data = {
									ug_id: this.ug_id,
									u_id: this.u_id,
									gm_id: gm_id,
									mk: 6,
									type: 2,
								};
								this.websocket.ws.send(JSON.stringify(data));
								break;
							case 40001:
								this.$toast.fail("删除失败");
								break;
						}
					})
					.catch((error) => {});
				})
				.catch(() => {});
				return false;
			} else {
				let that = this;
				this.$dialog
				.confirm({
					title: "删除消息",
					message: "确认删除该条消息吗？",
				})
				.then(() => {
					var params = {
						m_id: gm_id,
						type: 2,
						u_id: this.u_id,
						token: this.token,
						num: Math.random(),
					};
					var url = this.Conf.serverUrl + "Friends/delMsg";
					this.$axios
					.post(url, this.$qs.stringify(params))
					.then((response) => {
						switch (response.data.code) {
							case 200:
								var data = {
									ug_id: this.ug_id,
									u_id: this.u_id,
									gm_id: gm_id,
									mk: 10,
								};
								this.websocket.ws.send(JSON.stringify(data));
								break;
							case 40001:
								this.$toast.fail("删除失败！");
								break;
						}
					  })
					  .catch((error) => {});
				})
				.catch(() => {});
			}
		},
		//复制信息
		Copy(gm_id, gm_from_id, create_time, ug_type, gm_content) {
			let url = gm_content;
			let oInput = document.createElement("input");
			oInput.value = gm_content;
			document.body.appendChild(oInput);
			oInput.select(); // 选择对象;
			document.execCommand("Copy"); // 执行浏览器复制命令
			this.$toast("复制成功");
			oInput.remove();
		},
		transMsg(gm_id, gm_from_id, create_time, ug_type, gm_content,duration) {
			this.$router.push({
				path: "/NewChat",
				query: {
					m_post_messages: gm_content,
					m_type: ug_type,
					duration:duration,
					url: "GroupChatroom",
				},
			});
		},
		onTextareaKeyDown() {
			if (event.keyCode == 13) {
				//如果按的是enter键 13是enter
				event.preventDefault(); //禁止默认事件（默认是换行）
				this.sendmsg(); //执行发送动作
			}
		},
	   //获取屏幕高度
		beforeMount() {
			const container =this.$refs.ref_content;
			var h = document.documentElement.clientHeight || document.body.clientHeight;
			container.scrollTop = h;
		},
		reloadMoreMsg() {
			if (!this.reloadMoreMsgFlag) {
				this.reloadMoreMsgFlag = true;
				setTimeout(() => {
					this.loadData(1);
					this.beforeMount();
					this.isloading = false;
				}, 2000);
			} else {
				this.isloading = false;
			}
			return true;
		},
		showface() {
			this.faceshow = true;
			this.functionshow = false;
			this.clickVoice(0);
			this.footHeight = 260;
			if (this.$refs.ref_content.scrollHeight > 0) {
				this.$nextTick(() => {
					this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
				});
			}
		},
		analyzeEmoji: function (cont) {
			return analyzeEmoji(cont);
		},
		// 返回
		onClickLeft() {
			this.$router.go(-1);
			var params = {
				u_id: this.u_id,
				token: this.token,
				num: Math.random(),
			};
			var url = this.Conf.serverUrl + "GroupChatroom/clearTempGmId";
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then((response) => {
			})
			.catch((error) => {});
		},
		isUrl(val) {
			//var reg = /([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/|[wW]{3}.|[wW][aA][pP].|[fF][tT][pP].|[fF][iI][lL][eE].)[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;
			//return reg.test(val);
			return chkURL(val);
		},
		//跳转网页
		CheckUrl(gm_content) {
			if (!this.isUrl(gm_content)) {
			} else {
				// this.$toast.fail("这个是网址");
				if (window.plus) {
				  plus.runtime.openURL(gm_content);
				} else {
				  window.open(gm_content);
				}
				return;
			}
		},
		// 跳转到群聊设置
		onClickRight() {
			this.$router.push({
				name: "GroupChatSet",
				query: {
				  ug_id: this.ug_id,
				},
			});
			localStorage.setItem("groupUrl", this.path.url);
		},
		// 监听服务端push回来的socket消息
		getMessage(msg) {
			var that = this;
			var data = JSON.parse(msg.data);
			if (data && data.m_type == "alert") {
				that.$toast(data.m_post_messages);
				return;
			}
		 
			switch (data.status) {
				case 1:
				case 2:
					// 重新连接socket fd改变，客户端与服务端token相等时，不退出登入
					if (that.token == data.token) {
						return;
					}
					// 用户在别处登录，客服端与服务端token不相等时
					// 客户端token 与 后台token不相等时，退出登入
					window.localStorage.clear();
					that.$dialog
					.alert({
					  message: data.message,
					})
					.then(() => {
						that.$router.push({ path: "/login" });
					});
					break;
				case 3:
					if (data.type == "1" && data.message == "deleteOk") {
						that.$refs["ref_msg_" + data.gm_id][0].innerHTML = "撤回了一条消息";
						that.$refs["ref_msg_" + data.gm_id][0].style.width = "100%";
						that.$refs["ref_msg_" + data.gm_id][0].style.fontSize = "12px";
						that.$refs["ref_msg_" + data.gm_id][0].style.color = "#969799";
						that.$refs["ref_msg_" + data.gm_id][0].style.lineHeight = "40px";
						return;
					} else if (data.type == "2" && data.message == "deleteOk") {
						that.$refs["ref_msg_1" + data.gm_id][0].innerHTML = "";
						return;
					} else if (data.tag == "del" && data.message == "deleteOk") {
						that.$refs["ref_msg_1" + data.gm_id][0].innerHTML = "";
						return;
					}
					if (data.data.ug_type == "alert") {
						that.$toast(data.data.gm_content);
						return;
					}
					// 只push到当前群聊
					if (data.ug_id == that.ug_id) {
						if (that.transtat != 1) {
							that.chatMessage.push(data.data);
						}
						that.transtat = "";
						setTimeout((_) => {
							if (that.$refs.ref_content.scrollHeight > 0) {
								that.$nextTick(() => {
									that.$refs.ref_content.scrollTop = that.$refs.ref_content.scrollHeight;
								});
							}
						}, 500);
					}
					if (data.tag == "one") {
						that.recordUnreadChat(data);
						// 发送者设置免打扰 朋友id+noDisturbing = 1 为免打扰
						var noDisturbing = localStorage.getItem(
						  data.data.m_from_user_id + "noDisturbing"
						);
						// console.log("groupchatroom发送者id", data.data.m_from_user_id);
						//播放声音
						if (that.u_id != data.data.m_from_user_id && noDisturbing != 1) {
							that.$refs.altaudio.currentTime = 0; //从头开始播放提示音
							that.$refs.altaudio.play(); //播放
						}
					}
					that.staticsMsgUnread();
					break;
				case 4:
					that.maxMsgId = data.gm_id;
					break;
				case 6:
					that.websocket.recordUnreadShareLike();
					that.websocket.staticsShareUnread();
					break;
				case 7:
					that.websocket.recordUnreadShareComment(data);
					that.websocket.staticsShareUnread();
					break;
				case 99:
					that.$toast('你有一条新的'+data.message);
					break;
				default:
					break;
			}
		},
		// 发送消息到服务端
		sendmsg() {
			if (!this.websocket.connected) {
				return this.$toast("连接马上建立，请稍候...！");
			}
			if (typeof this.content == "undefined" || !this.content || this.content.trim() == "") {
				return this.$toast("输入不能为空！");
			} else {
				var userInfo = JSON.parse(localStorage.getItem("userInfo"));
				var data = {
					message: utf16toEntities(this.content),
					ug_id: this.ug_id,
					u_id: this.u_id,
					mk: 2,
					ug_type: "text",
					u_headportrait: this.userinfo.u_headportrait,
					// gm_id: randomWord(false, 3),
					gm_id: this.u_id + "_" + this.rannumber,
					ug_admin_id: this.ug_admin_id,
					ug_group_nick: this.ug_group_nick,
					u_nickname: this.userinfo.u_nickname,
					u_login_id: this.userinfo.u_login_id,
					u_name: this.userinfo.u_name,
				};
				++this.rannumber;
				this.websocket.ws.send(JSON.stringify(data));
				this.content = "";
				setTimeout((_) => {
					if (this.$refs.ref_content.scrollHeight > 0) {
						this.$nextTick(() => {
							this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
						});
					}
				}, 100);
		  }
		},
		loadLatestMsg() {
			if (this.latestInterTmer) {
				clearInterval(this.latestInterTmer);
			}
			if (this.connecting) return;
			let that = this;
			this.latestInterTmer = setInterval(() => {
				that.loadData(2);
			}, 2000);
		},
		headPortrait(id) {},
		showFunction() {
			this.functionshow = true;
			this.faceshow = false;
			this.clickVoice(0);
			this.footHeight = 140;
			if (this.$refs.ref_content.scrollHeight > 0) {
				this.$nextTick(() => {
					this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
				});
			}
		},
		closeOther() {
			this.functionshow = false;
			this.faceshow = false;
			this.footHeight = 60;
			if (this.$refs.ref_content.scrollHeight > 0) {
				this.$nextTick(() => {
					this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
				});
			}
		},
		getOwOlistUrl() {
			return OwOlistUrl;
		},
		// 选择表情包
		selectOwO(title) {
			this.content += title;
		},
		// 输入框获得焦点时表情框隐藏
		showOf() {
			this.show = false;
		},
		// 切换语音软键盘
		clickVoice(e) {
			this.voice = e;
			if (e == 1) {
				this.show = false;
				this.functionshow = false;
				this.faceshow = false;
			}
			this.footHeight = 60;
		},
		//录制语音
		handleBtnClick() {
			if (!this.websocket.connected) {
				return this.$toast("连接马上建立，请稍候...！");
			}
			let that = this;
			rc.start()
			.then(() => {
				that.voiceStartTime = new Date().getTime();
				that.recordimg = true;
				that.$refs.voiceCountDown.reset();
				that.$refs.voiceCountDown.start();
			})
			.catch((error) => {
				that.recordimg = false;
				this.$toast("获取麦克风失败,不能录音哦");
			});
		},
		cancel_voice() {
			this.recordimg = false;
			rc.clear();
		},
		// 发送语音
		send_voice() {
			if (!this.recordimg) return;
			if (!this.websocket.connected) {
				return this.$toast("连接马上建立，请稍候...！");
			}
			this.$toast("请稍候...");
			this.recordimg = false;
			rc.pause();
			let voiceTimes = new Date().getTime() - this.voiceStartTime;
			let that = this;
			var wav = rc.getRecord({
				encodeTo: ENCODE_TYPE.WAV,
				compressible: true,
			});
			var formData = new window.FormData();
			formData.append("audio", wav, Date.parse(new Date()) + ".wav");
			let headers = { "Content-Type": "multipart/form-data" };
			//  this.$axios.defaults.withCredentials = true;
			var url = this.Conf.serverUrl + "Chat/uploadAudio" + "?num=" + Math.random();
			this.$axios
			.post(url, formData, headers)
			.then((response) => {
					if (response.data.audioUrl) {
						var data = {
							message: response.data.audioUrl,
							ug_id: this.ug_id,
							u_id: this.u_id,
							mk: 2,
							ug_type: "audio",
							duration: voiceTimes,
							u_headportrait: that.userinfo.u_headportrait,
							gm_id: this.u_id + "_" + this.rannumber,
							ug_admin_id: that.ug_admin_id,
							ug_group_nick: that.ug_group_nick,
							u_nickname: that.userinfo.u_nickname,
							u_login_id: that.userinfo.u_login_id,
							u_name: that.userinfo.u_name,
						};
						++this.rannumber;
						this.websocket.ws.send(JSON.stringify(data));
						//this.websocket.ws.onmessage = this.getMessage;
				  }
				  rc.clear();
			})
			.catch((err) => {});
		},
		// 上传之前检测图片类似返回true和false会影响到onRead函数
		beforeRead(file) {
			return chkImgType(file);
		},
		// 发送图片
		filesSend() {
			if (!this.websocket.connected) {
				return this.$toast("连接马上建立，请稍候...！");
			}
			if (typeof this.data.message == "undefined" || !this.data.message ||this.data.message.trim() == "" ) {
				return this.$toast("不能为空！");
			} else {
				this.$toast("请稍候...");
				var url = this.Conf.serverUrl + "Chat/uploadImg" + "?num=" + Math.random();
				this.$axios
				.post(url, this.$qs.stringify(this.data))
				.then((response) => {
					if (response.data.imageUrl) {
						this.data.message = response.data.imageUrl;
						this.websocket.ws.send(JSON.stringify(this.data));
						this.data = {};
						this.fileList = [];
					} else if (response.data.msg) {
						this.$toast(response.data.msg);
					}
				})
				.catch((error) => {});
			}
			this.photoShow = false;
		},
		// 上传图片
		async onSend(file) {
			if (!this.websocket.connected) {
				return this.$toast("连接马上建立，请稍候...！");
			}
			let that = this;
			setTimeout(() => {
				compUploadImg(file, function (f) {
				  that.$toast("请稍候...");
				  let data = {};
				  data.message = file.content;
				  data.ug_id = that.ug_id;
				  data.u_id = that.u_id;
				  data.mk = 2;
				  data.ug_type = "image";
				  data.u_headportrait = that.userinfo.u_headportrait;
				  data.gm_id = that.u_id + "_" + that.rannumber;
				  data.ug_admin_id = that.ug_admin_id;
				  data.ug_group_nick = that.ug_group_nick;
				  data.u_nickname = that.userinfo.u_nickname;
				  data.u_login_id = that.userinfo.u_login_id;
				  data.u_name = that.userinfo.u_name;
				  ++that.rannumber;
				  var url = that.Conf.serverUrl + "Chat/uploadImg";
				  that.$axios
					.post(url, that.$qs.stringify(data))
					.then((response) => {
						if (response.data.imageUrl) {
							data.message = response.data.imageUrl;
							that.websocket.ws.send(JSON.stringify(data));
						} else if (response.data.msg) {
							this.$toast(response.data.msg);
						}
					})
					.catch((error) => {});
				});
			}, 500);
		},
		// 拍照上传图片
		onRead(file) {
			if (!this.websocket.connected) {
				return this.$toast("连接马上建立，请稍候...！");
			}
			let that = this;
			compUploadImg(file, function (f) {
				let data = {};
				data.message = file.content;
				data.ug_id = that.ug_id;
				data.u_id = that.u_id;
				data.mk = 2;
				data.ug_type = "image";
				data.u_headportrait = that.userinfo.u_headportrait;
				data.gm_id = that.u_id + "_" + that.rannumber;
				data.ug_admin_id = that.ug_admin_id;
				data.ug_group_nick = that.ug_group_nick;
				data.u_nickname = that.userinfo.u_nickname;
				data.u_login_id = that.userinfo.u_login_id;
				data.u_name = that.userinfo.u_name;
				that.data = data;
			});
			++that.rannumber;
		},
		//上传视频
		sendVideo() {
			if (!this.websocket.connected) {
				return this.$toast("连接马上建立，请稍候...！");
			}
			var that = this;
			let filesize = videoSizeLimit;
			let filelength = videoLengthLimit;
			var file = that.$refs.uploadVideo.files[0];
			var formData = new FormData();
			if (file.size > filesize) {
				that.$toast("视频不能超过" + filesize / (1024 * 1024) + "M");
				return;
			} else if (file.length > filelength) {
				that.$toast("视频不能超过" + filelength + "s");
				return;
			} else {
				that.$toast("请稍候...");
				formData.append("video", file);
				let headers = { "Content-Type": "multipart/form-data" };
				that.videoFlag = true;
				var url = this.Conf.serverUrl + "Chat/uploadVideo";
				that.$axios
				  .post(url, formData, headers)
				  .then((response) => {
					that.videoFlag = false;
					if (response.data.videoUrl) {
					  var data = {
						message: response.data.videoUrl,
						duration: response.data.duration,
						ug_id: that.ug_id,
						u_id: that.u_id,
						mk: 2,
						ug_type: "video",
						u_headportrait: that.userinfo.u_headportrait,
						gm_id: that.u_id + "_" + that.rannumber,
						ug_admin_id: that.ug_admin_id,
						ug_group_nick: that.ug_group_nick,
						u_nickname: that.userinfo.u_nickname,
						u_login_id: that.userinfo.u_login_id,
						u_name: that.userinfo.u_name,
					  };
					  ++that.rannumber;
					  that.websocket.ws.send(JSON.stringify(data));
					}
				  })
				  .catch((err) => {});
			}
		},
		playVideo(src, m_id) {
			var that = this;
			// var video = document.getElementById(m_id);
			that.videoshow = true;
			var video = that.$refs.msgvideo;
			that.videoUrl = src;
			if (video.paused) {
				that.FullSrceen();
				this.$nextTick(() => {
					video.play();
				});
				video.addEventListener("ended", function () {
					that.videoshow = false;
					video.load();
					that.exitFullscreen();
				});
				document.addEventListener("fullscreenchange", function (e) {
					if (document.fullscreenElement) {
						video.play();
					} else {
						that.videoshow = false;
						video.pause();
					}
				});
				document.addEventListener("webkitfullscreenchange", function (e) {
					const isFullScreen =
					document.fullscreenEnabled ||
					window.fullScreen ||
					document.webkitIsFullScreen ||
					document.msFullscreenEnabled;
					if (isFullScreen) {
						video.play();
					} else {
						that.videoshow = false;
						video.pause();
						// video.load();
					}
				});
			}
		},
		//进入全屏
		FullSrceen() {
			var video = this.$refs.msgvideo;
			if (video.requestFullscreen) {
				video.requestFullscreen();
			} else if (video.mozRequestFullScreen) {
				video.mozRequestFullScreen();
			} else if (video.webkitRequestFullScreen) {
				video.webkitRequestFullScreen();
			} else if (video.msRequestFullscreen) {
				video.msRequestFullscreen();
			} else {
				this.videoshow = false;
				video.play();
			}
		},
		//退出全屏
		exitFullscreen() {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.oRequestFullscreen) {
				document.oCancelFullScreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			}
		},
		getNotice() {
			var params = {
				u_id: this.u_id,
				token: this.token,
				ug_id: this.ug_id,
			};
			var url = this.Conf.serverUrl + "Groups/getGroupNotice";
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then((response) => {
				if (response.data.code == 200) {
					this.groupNotice = response.data.notice.ug_notice;
				}
			})
			.catch((error) => {});
		},
		noticeshow() {
			this.showmsg = true;
		},
		showImage(img) {
			this.showImgDialog = true;
			this.image_url = img;
		},
		downImg(img) {
			if (!window.plus) return;
			var self = this;
			plus.gallery.save(
			(this.image_url = img),
			function () {
				return self.$toast("图片已保存到相册!");
			},
			function () {
				return self.$toast("保存失败，请重试!");
			}
			);
		},
		playaudio(src, m_id) {
			var that = this;
			that.musicUrl = src;
			var msgaudio = that.$refs.msgaudio;
			var nextsplaya = document.getElementById(that.nextplay);
			if(that.nextplay){
				nextsplaya.src = require("../../assets/img/center/pause.png");
				msgaudio.pause();
				msgaudio.load();
			}
			that.nextplay = m_id;
			var playa = document.getElementById(m_id);
			if (msgaudio.paused) {
				//如果已停止则播放录音并更换图标
				playa.src = require("../../assets/img/center/play.gif");
				setTimeout(() => {
				  msgaudio.play();
				}, 1000);
				msgaudio.addEventListener("ended", function () {
				  playa.src = require("../../assets/img/center/pause.png");
				});
			} else {
				playa.src = require("../../assets/img/center/pause.png");
				msgaudio.pause();
				msgaudio.load();
			}
		},
		choose(gm_id) {
			this.show1 = false;
			this.select = true;
		},
		//多选转发
		transmit() {
			var that = this;
			var len = that.chatMessage.length;
			for (var i = 0; i < len; i++) {
				if (this.selectArr.indexOf(i) >= 0) {
					that.subArr.push(that.chatMessage[i]);
				}
			}
			if (that.subArr.length == 0) {
				this.$toast.fail("请勾选后再转发");
			} else {
				this.$router.push({
					path: "/NewChat",
					query: {
						m_post_messages: that.subArr,
						url: "GroupChatroom",
					},
				});
			}
		}
	},
	beforeDestroy() {
		if (this.latestInterTmer)  clearInterval(this.latestInterTmer);
		if (this.Loop) clearTimeout(this.Loop);
		if (this.timeoutnum) clearTimeout(this.timeoutnum);
		if (window.timer) clearInterval(window.timer);
		if (this.chkWebsocketTimer) clearTimeout(this.chkWebsocketTimer);
	}
};
</script>
<style lang="less">
</style>


// WEBPACK FOOTER //
// src/components/Group/GroupChatroom.vue